import React from 'react'
import styled from 'styled-components'

export default function Footer() {
  return <Container></Container>
}

const Container = styled.footer`
  width: 100%;
`
